interface PreviewTextContentProps {
  title: string
  heading: string
  description: string
  reverse?: boolean
}

const PreviewTextContent = ({
  title,
  heading,
  description
}: PreviewTextContentProps) => {
  const renderTextWithLineBreaks = (text: string) => {
    return text.split('\n').map((line, index) => <div key={index}>{line}</div>)
  }

  return (
    <section
      className={`relative mx-auto flex flex-col text-center sm:min-w-[500px] sm:text-start`}
    >
      <h2 className="font-pretendard-bold text-[16px] text-primary sm:text-[20px]">
        {title}
      </h2>
      <h3 className="mb-[14px] mt-[15px] text-[24px] leading-[32px] text-main-light-2 sm:mb-[20px] sm:mt-[20px] sm:text-[36px] sm:leading-[48px] sm:tracking-[-0.02em] dark:text-main-dark-2">
        {renderTextWithLineBreaks(heading)}
      </h3>
      <h4 className="text-[15px] leading-[22px] text-main-light-3 sm:text-[20px] sm:leading-[32px] dark:text-main-dark-3">
        {renderTextWithLineBreaks(description)}
      </h4>
    </section>
  )
}

export default PreviewTextContent
